import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import { vendorApi } from 'api';

// VENDOR_LIST_COLUMNS 대신 getVendorListColumns 사용
import { getVendorListColumns, VENDOR_FILTER_OPTIONS } from 'constants/vendor';

import { useUserContext } from 'providers/UserProvider';
import paths from 'routes/paths';

const Vendors = () => {
  const navigate = useNavigate();
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  // tenant/warehouse 기반 컬럼 생성
  const columns = useMemo(
    () => getVendorListColumns(tenant, warehouse),
    [tenant, warehouse],
  );

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => navigate(paths.vendors.create(tenant, warehouse))}
    >
      Create Vendor
    </Button>
  );

  return (
    <Table
      title="Vendor List"
      apiService={vendorApi}
      sortable={true}
      columns={columns}
      filterOptions={VENDOR_FILTER_OPTIONS}
      headerActions={headerActions}
    />
  );
};

export default Vendors;
